export default "__VITE_ASSET__65a22fa4__"